export const useResourceMetadata = () => {
  const metadata = useState<Record<string, any> | null>(
    "resource-metadata",
    () => null
  );
  const setMetadata = (data: Record<string, any> | null) => {
    metadata.value = data;
  };
  return { metadata, setMetadata };
};

